import {FuncionesUsuarioEnum, TipoIconoEnum, TipoOpcionMenuEnum} from '@enumeraciones/Enumeraciones.enum';

export class OpcionMenu {
    public PantallaId: number = 0;
    public TipoModulo: TipoOpcionMenuEnum = TipoOpcionMenuEnum.Pantalla;
    public Ruta: string = '';
    public Titulo: string = '';
    public Icono: string = 'fa-circle-o';
    public PantallaInicio: boolean = false;
    public Abierto: boolean = false;
    public Activo: boolean = false;
    public TipoIconoId: TipoIconoEnum = TipoIconoEnum.AweSomeFont;
    public SubMenu: Array<OpcionMenu> = [];
    public Orden: number = 0;
    public OrdenInicio: number = 0;
    public Funcion: FuncionesUsuarioEnum = FuncionesUsuarioEnum.CambiarPassword;

    constructor(init?: Partial<OpcionMenu>) {
        Object.assign(this, init);
    }
}
